import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../../shared/base-api-template-service.model';
import { Core2Config } from '../../../shared/core2Config';
import { PickPackQueueContainerModel } from '../../../../../../../models/aggregates/erp/delivery/pick-pack-queue/pick-pack-queue-container.model';
import { FinancialPickPackQueueContainerModel } from '../../../../../../../models/aggregates/erp/delivery/pick-pack-queue/finanial-pick-pack-queue-container.model';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel } from '../../../shared';

@Injectable({
  providedIn: 'root'
})
export class PickPackQueueService extends BaseApiTemplateService<PickPackQueueContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi-pick-pack-queue/' + BaseApiTemplateService.BACKOFFICE_EP;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi-pick-pack-queue/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi-pick-pack-queue/' + BaseApiTemplateService.BACKOFFICE_EP;
    this.httpClient = http;
  }

  public getPickPackQueueByQuery(dtoObject: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path + '/get-outstandings/query';
    }
    return this.httpClient.post<ApiResponseModel<PickPackQueueContainerModel>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public pickPackQueueAllocation(dtoObject: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<ApiResponseModel<PickPackQueueContainerModel>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  /** Post a FinancialPickPackQueueContainer to the queue directly */
  public upsertAdhoc(container: FinancialPickPackQueueContainerModel, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'fi-pick-pack-queue/' + 'ad-hoc/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    }
    return this.httpClient.post<BasicApiResponseModel<FinancialPickPackQueueContainerModel>>(
      this.apiUrl, container, this.getHttpHeader(visa)
    );
  }
}